import { each, without, cloneDeep, reduce, isNull, isUndefined, isArray, includes } from 'lodash';
import { CLIENT_TYPE } from '../constants/auth/clientType';

var AuthenticationStore = require("../store/authenticationStore");
var AppStore = require('../store/appStore');
var registerAction = require('../action/registerErrorAction');
var AppError = require('../utils/appError');

var configPromise = require("../config").configPromise;

var Api = function () {

  var debug = true;

  var DATA_TYPE_JSON = "json";

  var CONTENT_TYPE_JSON = "application/json";

  var traceError = function (err) {
    if (debug) {
      console.trace(err);
    }
  };

  var TOKEN_URL = "/Token",
    GRANT_TYPE_REFRESH_TOKEN = "refresh_token",
    CLIENT_WEB = "web";

  var METHOD_GET = "GET",
    METHOD_POST = "POST",
    METHOD_PUT = "PUT",
    METHOD_DELETE = "DELETE",
    METHOD_PATCH = "PATCH";

  var HEADER_AUTHORIZATION = 'Authorization',
    HEADER_ACCEPT_LANGUAGES = 'Accept-Language';

  var APP_ERROR_CODES = [401, 403, 404, 500, 503];

  var statusCodeCallbacks = {
    401: function (xhr) {
    },
    403: function (xhr) {
      registerAction.registerError(new AppError(403));
    },
    404: function (xhr) {
      /*var error = new AppError(404);
      error.errorTitle = AppError.messages.OBJECT_NOT_FOUND.title;
      error.errorMessage = AppError.messages.OBJECT_NOT_FOUND.message;
      registerAction.registerError(error);*/
    },
    500: function (xhr) {
      registerAction.registerError(new AppError(500));
    },
    503: function (xhr) {
      registerAction.registerError(new AppError(503));
    }
  };

  var getRequestHeaders = function () {
    var headersObject = {};

    headersObject[HEADER_ACCEPT_LANGUAGES] = AppStore.getAcceptLanguageHeader();

    if (AuthenticationStore.isLoggedIn()) {
      headersObject[HEADER_AUTHORIZATION] = AuthenticationStore.getAuthorizationValue();
    }

    var headersCount = 0;
    for (var i in headersObject) {
      if (headersObject.hasOwnProperty(i)) {
        headersCount++;
      }
    }

    return !!headersCount ? headersObject : false;
  };

  var getRequestObject = function (url, data, method, dataType) {
    dataType = dataType || DATA_TYPE_JSON;
    method = method || METHOD_GET;
    return {
      url: url,
      data: data,
      method: method,
      dataType: dataType,
      headers: getRequestHeaders(),
      statusCode: statusCodeCallbacks,
      beforeSend: executeInterceptors
    }
  };

  var getTokenAfter401 = null;

  let interceptors = [];


  const executeInterceptors = (xhr, settings) => {
    each(interceptors, interceptor => { interceptor(xhr, settings) });
  };

  const makeRequest = async function (requestObject) {
    const primaryRequestObject = cloneDeep(requestObject);
    try {
      const response = await executeRequest(requestObject);
      return response;
    } catch (errorData) {
      if (errorData.status !== 401) {
        throw errorData;
      }

      if (!!getTokenAfter401) {
        return executeRequest(primaryRequestObject);
      }

      getTokenAfter401 = refreshToken().then(executeRequest.bind(this, primaryRequestObject));
      return getTokenAfter401;
    }
  };

  var executeRequest = function (requestObject) {
    return new Promise(function (resolve, reject) {
      requestObject.success = function (response, statusCode, xhr) {
        resolve(response)
      };
      requestObject.error = function (xhr, type, error) {
        if (xhr.status === 400 || xhr.status === 409) {
          resolve(new AppError(xhr.status, xhr.responseJSON));
        } else if (xhr.status === 404) {
          var error = new AppError(404);
          error.errorTitle = AppError.messages.OBJECT_NOT_FOUND.title;
          error.errorMessage = AppError.messages.OBJECT_NOT_FOUND.message;
          reject(error);
        } else {
          var errorData = {error: error, status: xhr.status};
          reject(errorData);
        }
      };

      Promise.all([getTokenAfter401])
        .then(() => {
          requestObject.headers = getRequestHeaders();
        })
        .then(() => {
          $.ajax(requestObject)
        });
    });
  };

  var refreshToken = function () {
    var token = AuthenticationStore.getRefreshToken();

    return configPromise
      .then(function (config) {
        var url = config.apiPath(TOKEN_URL),
          postData = {
            grant_type: GRANT_TYPE_REFRESH_TOKEN,
            refresh_token: token,
            client_id: CLIENT_TYPE.getClientTypeFromToken(AuthenticationStore.getToken()) || CLIENT_TYPE.WEB
          };
        var requestObject = getRequestObject(url, postData, METHOD_POST);
        requestObject.headers = false;
        return new Promise(function (resolve, reject) {
          requestObject.success = function (response, statusCode, xhr) {
            AuthenticationStore.saveToken(response);

            getTokenAfter401 = null;
            resolve(response);
          };
          requestObject.error = function (xhr, type, error) {
            AuthenticationStore.logout();

            getTokenAfter401 = null;
            window.location.reload();
            reject();
          };
          $.ajax(requestObject);
        })
      });
  };

  this.addInterceptor = function(interceptor) {
    if (!includes(interceptors, interceptor)) {
      interceptors.push(interceptor);
    }
  };

  this.removeInterceptor = function(interceptor) {
    interceptors = without(interceptors, interceptor);
  };

  this.get = function (url, data) {
    if (data && data.toJSON) {
      data = data.toJSON();
    }
    var request = getRequestObject(url, data, METHOD_GET);
    return makeRequest(request);
  };

  this.post = function (url, data) {
    var request = getRequestObject(url, JSON.stringify(data), METHOD_POST);
    request.contentType = "application/json";
    return makeRequest(request);
  };

  this.postUrlEncoded = function (url, data) {
    var request = getRequestObject(url, data, METHOD_POST);
    return makeRequest(request);
  };

  this.put = function (url, data) {
    var request = getRequestObject(url, JSON.stringify(data), METHOD_PUT);
    request.processData = false;
    request.contentType = CONTENT_TYPE_JSON;
    return makeRequest(request);
  };

  this.delete = function (url, data) {
    var request = getRequestObject(url, JSON.stringify(data), METHOD_DELETE);
    request.processData = false;
    request.contentType = CONTENT_TYPE_JSON;
    return makeRequest(request);
  };

  this.patch = function (url, data) {
    var request = getRequestObject(url, JSON.stringify(data), METHOD_PATCH);
    request.processData = false;
    request.contentType = CONTENT_TYPE_JSON;
    return makeRequest(request);
  };

  /*TODO: unhandled api request*/
  this.postFile = async function (url, files, useAuth, progress, additionalData) {
    const formData = this._createFileFormData(files);
    this._fillFormDataWithAdditionalInfo(formData, additionalData);

    const headers = {};
    headers.Accept = CONTENT_TYPE_JSON;
    if (AuthenticationStore.isLoggedIn() && useAuth) {
      headers[HEADER_AUTHORIZATION] = AuthenticationStore.getAuthorizationValue();
    }

    const response = await $.ajax(this._getFileUploadRequestObject('POST', url, headers, formData, progress));
    return { body: response };
  };

  this.putFile = (url, file, progress) => {
    const headers = {
      Accept: CONTENT_TYPE_JSON,
      'Content-Type': file.type
    };
    return $.ajax(
      this._getFileUploadRequestObject('PUT', url, headers, file, progress)
    );
  };

  this._createFileFormData = (files) => {
    const formData = new window.FormData();
    each(files, (file, index) => {
      formData.append(`file[${index}]`, file, file && file.name);
    });
    return formData;
  };

  this._fillFormDataWithAdditionalInfo = (formData, info) => {
    if (!info) {
      return;
    }
    each(info, (value, key) => {
      formData.append(key, value);
    });
  };

  this._getFileUploadRequestObject = (method = 'POST', url, headers = {}, data = {}, progressHandler = () => {}) => {
    return {
      url,
      type: method,
      data,
      cache: false,
      contentType: false,
      processData: false,
      headers,

      xhr: this._getFileUploadXhr(progressHandler)
    };
  };

  this._getFileUploadXhr = (progressHandler = () => {}) => {
    return () => {
      const xhr = $.ajaxSettings.xhr();

      if (xhr.upload) {
        xhr.upload.addEventListener('progress', (event) => {
          const percentLoaded = (event.loaded / event.total) * 100;
          progressHandler(percentLoaded);
        }, false);
      }

      return xhr;
    };
  };

  this.createApiLink = function (url, data) {
    data = data || {};

    if (typeof data != "object") return url;
    data.access_token = AuthenticationStore.getAccessToken();

    var query = this.objectToQueryString(data);
    url = url + "?" + query;

    return url;
  };

  this.objectToQueryString = function (obj) {
    var qs = reduce(obj, function (result, value, key) {
      if (!isNull(value) && !isUndefined(value)) {
        if (isArray(value)) {
          result += reduce(value, function (result1, value1) {
            if (!isNull(value1) && !isUndefined(value1)) {
              result1 += key + '=' + value1 + '&';
              return result1
            } else {
              return result1;
            }
          }, '')
        } else {
          result += key + '=' + value + '&';
        }
        return result;
      } else {
        return result
      }
    }, '').slice(0, -1);
    return qs;
  };

  this.traceError = traceError;
};


module.exports = new Api();
